// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.equipararViagens.title': 'Equiparar viagens',
    'shipments.equipararViagens.descricao': 'Sugestões por data e placa entre as cargas do HUB e as viagens da frente {{frente}} do Protheus. Aceite ou recuse cada uma: só o que você mexer é gravado.',
    'shipments.equipararViagens.descricaoVarias': 'Sugestões por data e placa entre as cargas do HUB e as viagens das frentes {{frentes}} do Protheus, lidas juntas. Aceite ou recuse cada uma: só o que você mexer é gravado.',
    'shipments.equipararViagens.conjuncao': ' e ',
    'shipments.equipararViagens.chipComPar': '{{count}} com par',
    'shipments.equipararViagens.chipSemPar': '{{count}} sem par',
    'shipments.equipararViagens.chipViagensLivres': '{{count}} viagens livres',
    'shipments.equipararViagens.chipTocadas': '{{count}} a gravar',
    'shipments.equipararViagens.chipOrfa': 'Órfã',
    'shipments.equipararViagens.chipSugestao': 'Sugestão',
    'shipments.equipararViagens.chipEquiparada': 'Equiparada',
    'shipments.equipararViagens.chipAceita': 'Aceita',
    'shipments.equipararViagens.chipRecusada': 'Recusada',
    'shipments.equipararViagens.chipDesfeita': 'Desfazer',
    'shipments.equipararViagens.aceitar': 'Aceitar sugestão',
    'shipments.equipararViagens.recusar': 'Recusar sugestão',
    'shipments.equipararViagens.aceitarTodas': 'Aceitar as {{count}} sugestões',
    'shipments.equipararViagens.cargaSemDados': 'Sem data ou placa',
    'shipments.equipararViagens.selecionarViagem': 'Viagem do ERP',
    'shipments.equipararViagens.semViagem': 'Sem viagem',
    'shipments.equipararViagens.buscarViagem': 'Buscar viagem…',
    'shipments.equipararViagens.equiparadaPor': 'Já equiparada à carga {{number}}',
    'shipments.equipararViagens.escolhidaNoutraLinha': 'Já escolhida em outra linha',
    'shipments.equipararViagens.aplicado': '{{count}} pares gravados, {{recusados}} sugestões recusadas, {{desfeitos}} desfeitos.',
    'shipments.equipararViagens.aplicadoComErros': '{{count}} pares gravados, {{errors}} com erro.',
    'shipments.equipararViagens.aplicarPares': 'Gravar {{count}} alterações',
    'shipments.equipararViagens.semCargas': 'Nenhuma carga para equiparar.',
    'shipments.equipararViagens.buscarCarga': 'Buscar motorista ou placa',
    'shipments.equipararViagens.limparBusca': 'Limpar busca',
    'shipments.equipararViagens.semResultadoNaBusca': 'Nenhuma carga com esse motorista ou placa.',
  },
  en: {
    'shipments.equipararViagens.title': 'Match trips',
    'shipments.equipararViagens.descricao': 'Suggestions by date and plate between HUB loads and the trips of Protheus front {{frente}}. Accept or refuse each one: only what you touch is saved.',
    'shipments.equipararViagens.descricaoVarias': 'Suggestions by date and plate between HUB loads and the trips of Protheus fronts {{frentes}}, read together. Accept or refuse each one: only what you touch is saved.',
    'shipments.equipararViagens.conjuncao': ' and ',
    'shipments.equipararViagens.chipComPar': '{{count}} paired',
    'shipments.equipararViagens.chipSemPar': '{{count}} unpaired',
    'shipments.equipararViagens.chipViagensLivres': '{{count}} free trips',
    'shipments.equipararViagens.chipTocadas': '{{count}} to save',
    'shipments.equipararViagens.chipOrfa': 'Orphan',
    'shipments.equipararViagens.chipSugestao': 'Suggestion',
    'shipments.equipararViagens.chipEquiparada': 'Matched',
    'shipments.equipararViagens.chipAceita': 'Accepted',
    'shipments.equipararViagens.chipRecusada': 'Refused',
    'shipments.equipararViagens.chipDesfeita': 'Undo',
    'shipments.equipararViagens.aceitar': 'Accept suggestion',
    'shipments.equipararViagens.recusar': 'Refuse suggestion',
    'shipments.equipararViagens.aceitarTodas': 'Accept all {{count}} suggestions',
    'shipments.equipararViagens.cargaSemDados': 'No date or plate',
    'shipments.equipararViagens.selecionarViagem': 'ERP trip',
    'shipments.equipararViagens.semViagem': 'No trip',
    'shipments.equipararViagens.buscarViagem': 'Search trip…',
    'shipments.equipararViagens.equiparadaPor': 'Already matched to load {{number}}',
    'shipments.equipararViagens.escolhidaNoutraLinha': 'Already chosen on another row',
    'shipments.equipararViagens.aplicado': '{{count}} pairs saved, {{recusados}} suggestions refused, {{desfeitos}} undone.',
    'shipments.equipararViagens.aplicadoComErros': '{{count}} pairs saved, {{errors}} failed.',
    'shipments.equipararViagens.aplicarPares': 'Save {{count}} changes',
    'shipments.equipararViagens.semCargas': 'No loads to match.',
    'shipments.equipararViagens.buscarCarga': 'Search driver or plate',
    'shipments.equipararViagens.limparBusca': 'Clear search',
    'shipments.equipararViagens.semResultadoNaBusca': 'No load with that driver or plate.',
  },
  es: {
    'shipments.equipararViagens.title': 'Equiparar viajes',
    'shipments.equipararViagens.descricao': 'Sugerencias por fecha y placa entre las cargas del HUB y los viajes del frente {{frente}} de Protheus. Acepta o rechaza cada una: solo lo que toques se guarda.',
    'shipments.equipararViagens.descricaoVarias': 'Sugerencias por fecha y placa entre las cargas del HUB y los viajes de los frentes {{frentes}} de Protheus, leídos juntos. Acepta o rechaza cada una: solo lo que toques se guarda.',
    'shipments.equipararViagens.conjuncao': ' y ',
    'shipments.equipararViagens.chipComPar': '{{count}} con par',
    'shipments.equipararViagens.chipSemPar': '{{count}} sin par',
    'shipments.equipararViagens.chipViagensLivres': '{{count}} viajes libres',
    'shipments.equipararViagens.chipTocadas': '{{count}} por guardar',
    'shipments.equipararViagens.chipOrfa': 'Huérfana',
    'shipments.equipararViagens.chipSugestao': 'Sugerencia',
    'shipments.equipararViagens.chipEquiparada': 'Equiparada',
    'shipments.equipararViagens.chipAceita': 'Aceptada',
    'shipments.equipararViagens.chipRecusada': 'Rechazada',
    'shipments.equipararViagens.chipDesfeita': 'Deshacer',
    'shipments.equipararViagens.aceitar': 'Aceptar sugerencia',
    'shipments.equipararViagens.recusar': 'Rechazar sugerencia',
    'shipments.equipararViagens.aceitarTodas': 'Aceptar las {{count}} sugerencias',
    'shipments.equipararViagens.cargaSemDados': 'Sin fecha ni placa',
    'shipments.equipararViagens.selecionarViagem': 'Viaje del ERP',
    'shipments.equipararViagens.semViagem': 'Sin viaje',
    'shipments.equipararViagens.buscarViagem': 'Buscar viaje…',
    'shipments.equipararViagens.equiparadaPor': 'Ya equiparada a la carga {{number}}',
    'shipments.equipararViagens.escolhidaNoutraLinha': 'Ya elegida en otra línea',
    'shipments.equipararViagens.aplicado': '{{count}} pares guardados, {{recusados}} sugerencias rechazadas, {{desfeitos}} deshechos.',
    'shipments.equipararViagens.aplicadoComErros': '{{count}} pares guardados, {{errors}} con error.',
    'shipments.equipararViagens.aplicarPares': 'Guardar {{count}} cambios',
    'shipments.equipararViagens.semCargas': 'Ninguna carga para equiparar.',
    'shipments.equipararViagens.buscarCarga': 'Buscar conductor o placa',
    'shipments.equipararViagens.limparBusca': 'Limpiar búsqueda',
    'shipments.equipararViagens.semResultadoNaBusca': 'Ninguna carga con ese conductor o placa.',
  },
}
